import { render, staticRenderFns } from "./delmap.vue?vue&type=template&id=6d08556d&scoped=true&"
import script from "./delmap.vue?vue&type=script&lang=js&"
export * from "./delmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d08556d",
  null
  
)

export default component.exports